<template>
    <div>
        <b-modal
            id="privacyModal"
            ref="privacyModal"
            :lazy="true"
            title-tag="h4"
            hide-footer
            :title-html="titleName + ' PRIVACY POLICY <br/> (rev. 20191113)'"
        >
            <!-- Modal Form -->
            <p>
                <b>We respect your privacy</b><br />Your privacy matters to us.
                This policy explains what information we collect from you, how
                we use it, and when we may disclose it. Please read this policy
                carefully. By accessing or using our websites or services
                (“Services”), you acknowledge that you have been informed of,
                and consent to, our practices with regard to your personal
                information. If you have any questions, please contact us at
                privacy@vettersoftware.com. This policy was last updated on
                December 12, 2019.
            </p>
            <p>
                <b>What This Policy Covers</b><br />This policy applies to
                information that we collect from you when you visit or use our
                Services. It does not apply to the privacy practices of third
                parties, including third-party services that you may use as part
                of using our Services. We are not responsible for the privacy
                policies of these third parties, and we encourage you to read
                and understand those privacy policies before using their
                services.
            </p>
            <p>
                <b>Data Protection Officer</b><br />Compliance with this policy
                (and overseeing data security generally) is the responsibility
                of our Data Protection Officer. If you wish make modifications,
                deletions, or additions to your personal information, or if you
                have general concerns about this policy or our data security
                practices, please contact us at privacy@vettersoftware.com.
            </p>
            <p>
                <b>Information We Collect</b><br />Our servers collect basic
                non-personal information about your use of our Services,
                including information about the device you are using to access
                our Services, your operating system and browser, your internet
                service provider, referring and exit pages, and the date and
                time of your use. We collect this information to better
                understand how our customers use our Services, to improve their
                experience while using our Services, and to monitor the security
                of our Services.
            </p>
            <p>
                We use cookies to help us identify and track usage of our
                Services. A cookie is a set of information that a website stores
                on your computer and that your browser provides to a website
                each time you return. We use information we collect from cookies
                to manage and improve our Services and your experience using our
                Services. For example, we may use cookies to remember your
                preferences, to protect your data, and to monitor the
                performance of our Services. If you do not wish to have cookies
                placed on your computer, you may set your browser to refuse
                cookies before using our Services. However, doing so may block
                your ability to use our Services, or cause certain features of
                our Services to not function properly.
            </p>
            <p>
                We also collect certain information that may uniquely identify
                your account, including information needed to create an account
                and use our Services, such as your name and email address. We do
                not disclose this information other than as described in this
                policy.
            </p>
            <p>
                <b>Information We Do Not Collect</b><br />We do not knowingly
                collect sensitive personal information, such as social security
                numbers, genetic data, health information, or religious
                information, nor any information from persons under the age of
                13. Other countries may have different minimum age limits. If
                you are below the minimum age for providing consent for data
                collection in your country, you may not use our Services. We do
                not track your online browsing activity on other online service,
                and we do not permit third parties to track your activity in our
                Services beyond the basic non-personal information described
                above.
            </p>
            <p>
                <b>Basis for Processing Information</b><br />The use of your
                personal information is necessary to perform the contract that
                we have with you. For example, we will use your information to
                fulfill your purchase of our Services, or to support your use of
                our Services. We use your personal information for our
                legitimate interests, such as to improve and promote our
                products and services, and for administrative, security, fraud
                prevention and legal purposes. We may rely on your consent to
                use your personal information for certain direct marketing
                purposes, such as sending you updates about our Services. You
                may withdraw your consent at any time through the unsubscribe
                feature provided with each marketing email, or by contacting us
                at privacy@vettersoftware.com.
            </p>
            <p>
                <b>How We Use Information</b><br />We use the information we
                collect to provide, maintain, protect and improve our Services,
                to develop new services, to respond to your requests for
                information, to contact you to inform you about our Services
                (such as to let you know about changes), to enforce the terms
                that govern your use of our Services, and to protect ourselves
                and our customers. We only disclose personal information to
                those of our employees and contractors that need to know that
                information in order to process it on our behalf, and that have
                agreed not to disclose it to others.
            </p>
            <p>
                <b>When We May Share Information</b><br />We do not share your
                personal information with any third party except: (a) when we
                have your permission to do so, (b) when we believe in good faith
                that we are required to do so by law, (c) to enforce our terms
                of service (including to detect, prevent or address potential
                violations, fraud, security or technical issues), or (d) to
                protect the rights, property, or personal safety of our
                employees, customers or the general public. We may share
                aggregated, non-personal information publicly to report trends,
                information about the general use of our Services, or to improve
                our Services. We will not rent or sell personal information to
                anyone.
            </p>
            <p>
                <b>How We Protect Information We Collect</b><br />We take
                measures that are reasonably necessary to protect against
                unauthorized access, alteration, disclosure or destruction of
                personal information. We encrypt transmissions of information
                using SSL, and we encrypt all data in our databases. We review
                our information collection, storage and processing practices
                regularly. Any employee or contractor who has access to personal
                information is bound by confidentiality obligations, and may be
                disciplined or terminated if he or she violates those
                obligations.
            </p>
            <p>
                <b>Accessing and Updating Your Information</b><br />Whenever you
                use our Services, you will have the ability to update your
                personal information through the Services. If you do not use our
                Services, but have provided us with your personal information
                for some other reason, you may contact us at
                privacy@vettersoftware.com to request that your information be
                updated or deleted. We will delete your information from our
                Services within 30 days after you cancel your subscription to
                our Services, or within a reasonable time after your request.
            </p>
            <p>
                <b>Information Processed on Behalf of our Customers</b><br />We
                host and process certain types of personal information on behalf
                of our customers that is collected by our customers about their
                customers, including names, email addresses, phone numbers,
                physical addresses, and transaction histories. We use this
                information to provide our Services to our customers. We have no
                direct relationship with the individuals whose personal data we
                process on behalf of our customers, but we work with our
                customers to help them provide notice to these individuals
                concerning the purpose for which personal information is
                collected, and to assist our customers in providing these
                individuals with access to their personal information in order
                to correct, amend, or delete it. We retain personal information
                that we process on behalf of our customers for as long as needed
                to provide our Services to those customers. We also retain and
                use this personal information as necessary to comply with our
                legal obligations, resolve disputes, and enforce our agreements.
                If our customer requests that we delete this information, we
                will do so promptly.
            </p>
            <p>
                <b>International Transfer of Information</b><br />Our Services
                are hosted in the United States, and information we collect will
                be stored and processed on our servers in the United States in
                accordance with this policy. Our employees and contractors that
                process personal information for us may be located in the United
                States or in other countries outside of your home country. By
                using the Services you consent to our transferring your
                information internationally.
            </p>
            <p>
                <b>Changes</b><br />We may modify this policy occasionally, so
                you should review this policy regularly. We'll highlight changes
                on this page for a period of time. Changes will be effective
                immediately. We will not reduce your rights under this policy
                without your consent. Your continued use of our Services after
                any change to this policy will constitute your acceptance of
                such change.
            </p>
        </b-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            titleName: ""
        };
    },
    mounted() {},
    methods: {
        open() {
            this.titleName = this.SYSTEM_COMPANY_NAME.toUpperCase();
            this.$refs.privacyModal.show();
        }
    }
};
</script>
